import * as React from 'react';
import styled from 'styled-components';
import { SeverityDisplayContainer } from '../../../containers/summary-item/SeverityDisplayContainer';
import { ISummaryMessage, SeverityType } from '../../../models';

export const SeverityWrapper = styled.div<{ hasMessages: boolean }>`
	${(props) =>
		props.hasMessages
			? `{
		margin-top: 15px;
	}`
			: ''}
`;
SeverityWrapper.displayName = 'SeverityWrapper';

export interface IErrorWarning {
	errors?: ISummaryMessage[];
	warnings?: ISummaryMessage[];
}

export class ErrorWarningDisplay extends React.Component<IErrorWarning> {
	public render() {
		const { errors, warnings } = this.props;
		const hasErrors = errors !== undefined && errors !== null && errors.length > 0;
		const hasWarnings = warnings !== undefined && warnings !== null && warnings.length > 0;

		return (
			<SeverityWrapper hasMessages={hasErrors || hasWarnings}>
				{errors &&
					errors.map((e, i) => (
						<div key={i}>
							<SeverityDisplayContainer severity={SeverityType.Error} message={e.message} relatedStep={e.relatedStep} />
						</div>
					))}
				{warnings &&
					warnings.map((w, i) => (
						<div key={i}>
							<SeverityDisplayContainer
								severity={SeverityType.Warning}
								message={w.message}
								relatedStep={w.relatedStep}
								showSeverityPrefix={true}
							/>
						</div>
					))}
			</SeverityWrapper>
		);
	}
}
